import { render, staticRenderFns } from "./ErrorTip.vue?vue&type=template&id=ac4b88c8&"
import script from "./ErrorTip.vue?vue&type=script&lang=js&"
export * from "./ErrorTip.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac4b88c8')) {
      api.createRecord('ac4b88c8', component.options)
    } else {
      api.reload('ac4b88c8', component.options)
    }
    module.hot.accept("./ErrorTip.vue?vue&type=template&id=ac4b88c8&", function () {
      api.rerender('ac4b88c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/ErrorTip.vue"
export default component.exports